<script setup>
defineProps({
  title: {
    type: String,
    default: undefined,
  },

  mode: {
    type: Number,
    default: 1,
    validator: (value) => [1, 2, 3].includes(value),
  },
});
const emit = defineEmits(['close']);
</script>

<template>
  <div class="modal-headers-base" :class="`modal-headers-base--mode--${mode}`">
    <div class="modal-headers-base__wrapper">
      <span class="modal-headers-base__font" v-html="title" />

      <button
        class="modal-headers-base__button"
        type="button"
        @click="emit('close')"
      >
        <CIcon class="modal-headers-base__icon" name="cross" />
      </button>
    </div>

    <slot />
  </div>
</template>

<style scoped lang="scss">
.modal-headers-base {
  $parent: &;

  display: flex;
  flex-shrink: 0;
  flex-direction: column;

  @include media-breakpoint-up(sm) {
    justify-content: center;
  }

  &__font {
    display: block;
    color: $color-text;
  }

  &__icon {
    flex-shrink: 0;
    color: $color-main-1;
  }

  &__wrapper {
    display: flex;
  }

  &__button {
    flex-shrink: 0;
  }

  &--mode {
    &--1 {
      gap: em(14);
      padding: em(42) em($gap-sm) em(30);

      @include media-breakpoint-up(sm) {
        padding-right: em($modal-padding);
        padding-left: em($modal-padding);
      }

      #{$parent} {
        &__font {
          font-size: em(20);
          font-weight: 600;
          line-height: 1;

          @include media-breakpoint-down(sm) {
            font-size: em(24);
            font-weight: 500;
            line-height: math.div(28, 24);
          }
        }

        &__icon {
          @include box(em(28));
        }

        &__wrapper {
          gap: em($gap-sm);
          align-items: center;
          justify-content: space-between;
        }
      }
    }

    &--2 {
      padding: em(42) em($gap-sm) em(20);

      @include media-breakpoint-up(sm) {
        padding-right: em(27);
        padding-left: em(27);
      }

      #{$parent} {
        &__font {
          font-size: em(20);
          font-weight: 500;
          line-height: math.div(24, 20);
        }

        &__icon {
          @include box(em(30));

          position: absolute;
          top: 50%;
          right: 0;
          transform: translateY(-50%);
        }

        &__wrapper {
          position: relative;
          justify-content: center;
          text-align: center;
        }
      }
    }

    &--3 {
      padding: em(20) em($gap-sm) em(18);

      @include media-breakpoint-up(sm) {
        padding-right: em(27);
        padding-left: em(27);
      }

      #{$parent} {
        &__font {
          font-size: em(20);
          font-weight: 500;
          line-height: math.div(24, 20);
        }

        &__icon {
          @include box(em(25));

          position: absolute;
          top: 50%;
          right: 0;
          transform: translateY(-50%);
        }

        &__wrapper {
          position: relative;
          justify-content: center;
          text-align: center;
        }
      }
    }
  }
}
</style>
